// The review address names a game ply in its fragment, `#ply=N`, so a reload
// or a shared link opens the same position. These rules are pure so they can
// be tested without a router.

/** The ply an address fragment names, if any. */
export function plyOf(hash: string): number | undefined {
  const match = /ply=(\d+)/.exec(hash);
  return match ? Number(match[1]) : undefined;
}

/** The fragment for a game ply: none at the starting position. */
export function fragmentFor(ply: number): string {
  return ply > 0 ? `#ply=${ply}` : '';
}

/** A hash as the browser reports it, with a bare `#` treated as none. */
export function normalHash(hash: string): string {
  return hash === '#' ? '' : hash;
}

/**
 * The game ply the address should name for a review state: the board's ply
 * along the game, or, while exploring a line or solving a puzzle, the game
 * ply the line branches from, since a line of the reader's own is not
 * addressable. Undefined when no game is open.
 */
export function addressPly(state: { game?: unknown; ply: number; exploring?: { fromPly: number } }): number | undefined {
  if (!state.game) return undefined;
  return state.exploring ? state.exploring.fromPly : state.ply;
}
